/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import { findACouponCategoryOrMakeOne } from '@/model/buffet/buffetApis'
import GlobalSettings from '@/GlobalSettings'
import StringEntity from '@/model/common/StringEntity'
import dayjs from 'dayjs'
import Dish, { loadAllCode } from '@/model/dish/Dish'

const entity = {
  price: {
    type: IKDataEntity.Types.Float,
    formConfig: {
      default: '',
      overwriteRule: true,
      rule: [
        v => /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || this.$t('pls_enter_a_right_price'),
      ],
      hint: 'priceIsCouponBalance',
    },

    header: false,
  },
  code: {
    tableConfig: {
      width: '160',
    },
    formConfig: {
      unique: true,
      uniqueTrackingList: Dish.getList,
      hint: 'EACouponRule',
    },
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'product_info', // 商品信息
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {},
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      },
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [
      StringEntity, StringEntity, StringEntity,
    ],
    header: false,
  },
}
const config = {
  load: async function () {
    return (await hillo.get('Dishes.php?op=showCoupons', { lang: GlobalSettings.getLang() })).content.map(item => {
      item.langs.map(it => {
        it.desc = it.description
        return it
      })
      item.id = item.dishId
      return item
    })
  },
  add: async function (item) {
    item.printGroupId = 10
    item.isActive = 1
    item.categoryId = (await findACouponCategoryOrMakeOne()).id
    item.attributeGroup = ''
    item.allergenGroup = ''
    item.extraPrintGroupIds = ''
    if (item.code === '自动生成') {
      const codes = await loadAllCode()
      for (let i = 0; i < 10000; i++) {
        if (!codes.includes(i.toString())) {
          item.code = i
        }
      }
      if (item.code === '自动生成') {
        item.code = dayjs().utcOffset()
      }
    }
    return (await hillo.postWithUploadFile('Dishes.php?op=add', {
      ...item,
      params: JSON.stringify(item),
    }, { showLoading: true })).content
  },
  edit: async function (item) {
    return (await hillo.postWithUploadFile('Dishes.php?op=update', {
      ...item,
      params: JSON.stringify(item),
    }))
  },
  remove: function (id) {
    return hillo.post('Dishes.php?op=delete', { id: id })
  },
}

export default IKDataEntity.ModelFactory(entity, config)

